module.exports = __webpack_public_path__ + "assets/img/iso27001@2x.8ba80d52.png";